import React from "react";
import styled from "styled-components";
import { Colors, TextFont } from "../config";

const StyledLink = ({
  linkText,
  handleClick,
  linkTextColor = Colors.brandTwo,
  linkTextSize = "1rem",
  linkTextWeight = "500",
  underlineRequired = true,
}) => {
  return (
    <LinkWrapper
      onClick={handleClick}
      linkTextColor={linkTextColor}
      underlineRequired={underlineRequired}
    >
      <TextFont
        fontColor={linkTextColor}
        fontSize={linkTextSize}
        fontWeight={linkTextWeight}
      >
        {linkText}
      </TextFont>
    </LinkWrapper>
  );
};

export default StyledLink;

const LinkWrapper = styled.div`
  border-bottom: ${(props) =>
    props.underlineRequired && "1px solid" + props.linkTextColor};
  width: fit-content;
  cursor: pointer;
`;
